import React from 'react';
import { useTranslation } from 'react-i18next';

export function Tabs({ view, setView, close }) {
  const { t } = useTranslation();
  const tabs = [
    { id: 'login', label: t('auth.login', 'Sign in') },
    { id: 'register', label: t('auth.signup', 'Sign up') },
    { id: 'magic', label: t('auth.magic_short', 'Magic link') }
  ];
  return (
    <div className="flex items-center gap-2 mb-4" role="tablist" aria-label="Authentication tabs">
      {tabs.map(t => (
        <button
          key={t.id}
          role="tab"
          aria-selected={view === t.id}
          onClick={() => setView(t.id)}
          className={
            `flex-1 text-center px-4 py-2 rounded-md text-[14px] transition-colors ` +
            (view === t.id
              ? 'bg-primary text-white'
              : 'text-gray-400 hover:text-white hover:bg-dark-lighter')
          }
        >
          {t.label}
        </button>
      ))}
      <button onClick={close} className="ml-2 shrink-0 text-gray-500 hover:text-primary" aria-label={t('common.close','Close')}>✕</button>
    </div>
  );
}
